import type { MetricItemDTO } from '@/types/agentEvents';
import { MetricIntervalPeriod } from '@/types/agentEvents';

/** When true, show an interval line chart instead of aggregate cards / progress UI. */
export function shouldShowAgentPerformanceIntervalChart(
  intervalPeriod: MetricIntervalPeriod,
  rows: MetricItemDTO[]
): boolean {
  return (
    intervalPeriod !== MetricIntervalPeriod.TOTAL &&
    rows.some(r => r.intervalStartTime != null) &&
    rows.length > 1
  );
}
